import { robotoRegular, scarpaGray500, spanishViridian500 } from '@habitech/shared';
import { RefObject } from 'react';
import styled from 'styled-components';

interface OrderInputProps {
    ref: RefObject<HTMLElement>;
}

export const OrderInputWrapper = styled.div<OrderInputProps>`
    display: flex;
    align-items: center;
    gap: 8px;

    .order {
        &__title {
            position: relative;
            font-size: 10px;
            letter-spacing: 2px;
            line-height: 24px;
            text-transform: uppercase;
            font-weight: 600;
            font-family: ${robotoRegular};
            color: ${scarpaGray500};
            text-align: left;
            /**TODO: Descomentar cuando se iimplemente ordenamiento */
            /* cursor: pointer; */
            transition: all 0.3s ease-in-out;

            &.active {
                color: ${spanishViridian500};
            }
        }

        &__buttons {
            &_container {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
            }

            &_icon {
                /**TODO: Descomentar cuando se iimplemente ordenamiento */
                /* cursor: pointer; */
                transition: all 0.3s ease-in-out;

                &.active {
                    color: ${spanishViridian500};
                }
            }
        }
    }
`;
